// extracted by mini-css-extract-plugin
module.exports = {"container":"Expand_container__3sl_d","summary":"Expand_summary__34ijc","header":"Expand_header__25VB9"};